module.exports = __webpack_public_path__ + "static/media/bb.d35efe6b.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/bb.svg
// module id = 772
// module chunks = 0